export const chunkData = (array: any[], size: number) => {
	const result = []
	for (let i = 0; i < array.length; i += size) {
		result.push(array.slice(i, i + size))
	}
	return result
}

export const handleWheel = (e: WheelEvent) => {
	e.stopPropagation()
}

export const detectIsInEgypt = () => {
	const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
	if (timezone === "Africa/Cairo") return true

	const locales = navigator.languages?.length
		? navigator.languages
		: [navigator.language]

	return locales.some((lang) => /(^|-)eg$/i.test(lang.replace("_", "-")))
}

export const formatHotlineValue = (value: string, isInEgypt: boolean) => {
	if (isInEgypt) return value

	const trimmed = value.trim()
	if (trimmed.startsWith("+20")) return trimmed

	const local = trimmed.startsWith("0") ? trimmed.slice(1) : trimmed
	return `+20 ${local}`
}
